export default __webpack_public_path__ + "static/media/empty-slot-hera-tiles.41f02ab3953067c2f42930361f9908f0.svg";